var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWharhouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.754,
    height: 48.127,
    viewBox: "0 0 57.754 48.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(-336 -824.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warehouse",
    transform: "translate(336 782.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 42.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M57.107,57.248,29.434,42.81a1.211,1.211,0,0,0-1.114,0L.647,57.248a1.2,1.2,0,0,0,.557,2.27h1.2V89.6a1.2,1.2,0,0,0,1.2,1.2H10.83a1.2,1.2,0,0,0,1.2-1.2V61.924H45.722V89.6a1.2,1.2,0,0,0,1.2,1.2h7.219a1.2,1.2,0,0,0,1.2-1.2V59.518h1.2a1.2,1.2,0,0,0,.557-2.27Zm-4.166,1.067v30.08H48.128V60.721a1.2,1.2,0,0,0-1.2-1.2h-36.1a1.2,1.2,0,0,0-1.2,1.2V88.394H4.814V58.315a1.2,1.2,0,0,0-.1-.475L28.877,45.234,53.038,57.84A1.2,1.2,0,0,0,52.941,58.315Z",
    transform: "translate(0 -42.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M155.677,320H141.239a1.2,1.2,0,0,0-1.2,1.2v1.2H129.207a1.2,1.2,0,0,0-1.2,1.2v12.032a1.2,1.2,0,0,0,1.2,1.2h26.47a1.2,1.2,0,0,0,1.2-1.2V321.205A1.2,1.2,0,0,0,155.677,320ZM140.036,334.44H130.41v-9.625h3.61v2.406a1.2,1.2,0,0,0,2.406,0v-2.406h3.61v9.625Zm14.438,0H142.442V322.408h4.813v3.61a1.2,1.2,0,0,0,2.406,0v-3.61h4.813V334.44Z",
    transform: "translate(-113.565 -288.72)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWharhouse);
export default __webpack_public_path__ + "static/media/wharhouse.798d9b52b65cc71c7d7979d6c0e8b35c.svg";
export { ForwardRef as ReactComponent };